// extracted by mini-css-extract-plugin
export default {"panel":"overrides_panel__EzaY9","maxW":"overrides_maxW__eZbt3","limitedInput":"overrides_limitedInput__sv49H"};